module.exports = __webpack_public_path__ + "static/cover-not-all-traffic-8a53af069581f571a67f64f2f693478f.png";